import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=49b00b60&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=49b00b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b00b60",
  null
  
)

export default component.exports